<template>
  <div class="spinners" v-if="spinners">
    <atom-spinner :animation-duration="1000" :size="100" color="#ff1d5e" />
  </div>
  <div class="error-alert bg-danger" v-if="controlPLC?.errorStatus">
    <atom-spinner :animation-duration="1000" :size="30" color="white" />
    <span>{{ `${$t('errorCode')} ${controlPLC?.errorCode}` }} :
      {{ $t(`fpr.errorDesc.${controlPLC?.errorCode}`) }}</span>
    <atom-spinner :animation-duration="1000" :size="30" color="white" />
  </div>
  <header v-if="this.auth.authority">
    <ul>
      <li @click="collapse"><i class="fas fa-bars btn-aside zoom"></i></li>
    </ul>
    <div class="fs-6">
      <p v-if="!this.machineNetwork">
        <span class="btn bg-danger text-white fs-5">{{ `${$t('alerts.awaitMachine')}` }}</span>
      </p>
      <p style="width: 125px" class="text-center" v-else-if="license">
        <span v-if="this.auth.tecnicalPersonal">{{ `${$t('developer')} ${this.$store.state.systemDate.slice(10,
          19)}` }}</span>
        <span v-else>{{ this.$store.state.systemDate }}</span>
      </p>
      <p v-else>
        <span class="btn bg-danger text-white fs-5">{{ $t('copyCard') }}</span>
      </p>
    </div>
    <ul>
      <li id="fsBtn" v-if="this.authority && this.machineNetwork" @click="logout()">
        <!-- style="color:#5396da;" -->
        <i class="fas fa-sign-out-alt"></i>
      </li>
      <li id="fsBtn" v-if="!this.authority && this.machineNetwork"
        @click="this.$router.push({ query: { login: 'login' } })">
        <i class="fas fa-sign-in-alt"></i>
      </li>
      <li>
        <span class="fs-3 opacity-75" v-if="this.machineNetwork">{{ this.config?.sub_id }}</span>
      </li>
      <li id="fsBtn" @click="fullScreen">
        <i class="fas fa-expand-arrows-alt zoom"></i>
      </li>
    </ul>
  </header>

  <nav v-if="this.auth.authority">
    <div class="logo-details big">
      <div id="logo-small" class="logo d-none">
        <img src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
      </div>
      <div id="logo-big" class="logo">
        <img src="@/assets/media/img/logo2.png" alt="" style="object-fit: contain" />
      </div>
    </div>
    <ul class="nav-list">
      <li class="nav-item">
        <div class="input-area-single">
          <select class="input" name="machineType" id="machineType" v-model="machineCode" @change="onMachineTypeChange">
            <option v-for="type in machineTypes" :key="type" :value="type">{{ type }}</option>
          </select>
        </div>
        <div class="input-area-single mt-2">
          <select class="input" name="mixtureLiter" id="mixtureLiter" v-model="selected_machine">
            <option v-for="(item, index) in filteredMachines" :key="item.machine_id || index" :value="String(item.machine_id)">
              {{ item.network ? `${item.code} \u{1F6DC}` : item.code }}
            </option>
          </select>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-home"></i>
          <router-link class="nav-title fw-bold" to="/">{{ $t('nav.home') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-plug"></i>
          <router-link class="nav-title fw-bold" to="/energy">{{ $t('nav.powerManagementList') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-exclamation-circle"></i>
          <router-link class="nav-title fw-bold" to="/errors">{{ $t('nav.alerts') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/tracking/components">{{ $t('nav.calibrations') }}</router-link>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.n_tracking') }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-chart-line"></i>
              <router-link class="nav-title fw-bold" to="/tourMonitor">{{ $t('nav.tourMonitor') }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-chart-line"></i>
              <router-link class="nav-title fw-bold" to="/chargeMonitor">{{ $t('nav.chargeMonitor') }}</router-link>
            </a>
          </li>
        </ul>
      </li>
      <hr>
      <li class="nav-item" v-if="this.config?.bilir?.status">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/tours">{{ $t('nav.tours') }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="this.config?.bilir?.status">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/lidar">{{ $t('items.lidar') }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="this.auth?.authority && this.config?.bilir?.status">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/parkur">{{ $t('parkur') }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="this.auth?.authority && this.config?.bilir?.status">
        <a class="nav-link">
          <i class="fas fa-spinner"></i>
          <router-link class="nav-title fw-bold" to="/tracking/config">{{ $t('settings') }}</router-link>
        </a>
      </li>
      <hr v-if="this.auth?.authority">
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link">
          <i class="fas fa-microchip"></i>
          <router-link class="nav-title fw-bold" to="/panel/tracking/follow">{{ $t('nav.n_tracking', { name: 'PLC' })
          }}</router-link>
        </a>
      </li>
      <li class="nav-item" v-if="this.auth?.authority">
        <a class="nav-link" @click="dropdown($event)">
          <i class="fas fa-lock-open"></i>
          <i class="fas fa-chevron-down arrow"></i>
          <span class="nav-title fw-bold">{{ $t('nav.n_control', { name: $t('general') }) }}</span>
        </a>
        <ul class="sub-nav">
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/system">{{ $t('nav.n_control', {
                name:
                  $t('system')
              }) }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/license">{{ $t('license.license') }}</router-link>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/tracking/network">{{ $t('network') }}</router-link>
            </a>
          </li>
          <li class="nav-item" v-if="this.auth?.authority">
            <a class="nav-link">
              <i class="fas fa-spinner"></i>
              <router-link class="nav-title fw-bold" to="/calibration/ports">{{ $t('nav.n_control', {
                name: $t('port')
              }) }}</router-link>
            </a>
          </li>
        </ul>
      </li>
    </ul>
    <div class="nav-profil">
      <div class="profil-img" @click="userSettings">
        <img src="@/assets/media/img/logo.png" alt="" style="object-fit: contain" />
      </div>

      <p class="profil-name line-limit">{{ 'www.itechrobotics.com.tr' }}</p>
    </div>
  </nav>

  <main class="container-xxxl" v-if="this.auth.authority">
    <div class="content">
      <div class="main-header">
        <p class="page-name">{{ this.breadcrumb[this.breadcrumb.length - 1] }}</p>
        <ul class="breadcrumb">
          <li><a href="/">{{ $t('nav.home') }}</a></li>
          <li v-for="(item, index) in this.breadcrumb" :key="index">{{ item }}</li>
        </ul>
      </div>
      <router-view @breadcrumb="breadcrumb = $event" />
    </div>
    <div class="perde" v-if="navOptionsBarShow" @click="navOptionsBar0()"></div>
    <div id="navOptionsBar" class="nav-options-bar">
      <div class="door-handle" @click="navOptionsBar0()">
        <i class="fas fa-cog bg-transparent"></i>
      </div>
      <div class="content">
        <div class="text-center mb-2">
          <p class="btn btn-sm btn-success">{{ `${$t('version')}: ${this.version}` }}</p>
        </div>
        <div class="nob-header">
          <p class="title mb-2 fw-bold">{{ $t('systemConf') }}</p>
        </div>
        <div class="row justify-content-center my-3">
          <div class="col-4 lang-box mb-2" @click="change_lang('tr')" role="button" aria-label="Türkçe" title="Türkçe">
            <img src="@/assets/media/img/lang/tr.png" alt="tr" class="user-img-sm" />
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('az')" role="button" aria-label="Azərbaycan" title="Azərbaycan">
            <img src="@/assets/media/img/lang/az.png" alt="az" class="user-img-sm" />
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('en')" role="button" aria-label="English" title="English">
            <img src="@/assets/media/img/lang/en.png" alt="en" class="user-img-sm" />
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ru')" role="button" aria-label="Русский" title="Русский">
            <img src="@/assets/media/img/lang/ru.png" alt="ru" class="user-img-sm" />
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('de')" role="button" aria-label="Deutsch" title="Deutsch">
            <img src="@/assets/media/img/lang/de.png" alt="de" class="user-img-sm" />
          </div>
          <div class="col-4 lang-box mb-2" @click="change_lang('ar')" role="button" aria-label="العربية" title="العربية">
            <img src="@/assets/media/img/lang/ar.png" alt="ar" class="user-img-sm" />
          </div>
        </div>
        <div v-if="this.auth?.authority">
          <div class="row" v-if="!this.config?.portList?.find(x => x.name == 'PLC')?.clockStatus">
            <div class="col-12 mt-2">
              <div class="text-center">
                <p class="fw-bold">{{ $t('systemClock') }}</p>
              </div>
            </div>
            <div class="col-6 text-center my-2">
              <span @click="this.systemDate.autoSet = !this.systemDate.autoSet" class="btn bg-success text-white"
                :class="{ 'bg-warning': !this.systemDate.autoSet }">{{ this.systemDate.autoSet ? $t('mode.automatic') :
                  $t('mode.manual') }}</span>
            </div>
            <div class="col-6 text-center my-2">
              <span @click="dateChange()" class="btn bg-info text-white">{{ $t('op.save') }}</span>
            </div>
            <div class="col-12" v-if="!this.systemDate.autoSet">
              <div class="input-area-single m-2">
                <input type="date" name="systemDate" id="systemDate" v-model="systemDate.date" style="height: 50px">
              </div>
            </div>
            <div class="col-12" v-if="!this.systemDate.autoSet">
              <div class="input-area-single m-2">
                <input type="time" name="systemTime" id="systemTime" v-model="systemDate.hour" style="height: 50px">
              </div>
            </div>
          </div>
        </div>
        <div>
        <div class="row" v-if="controlPLC?.battery > 0">
          <div class="text-center">
            <p class="fw-bold">{{ $t('items.battery') }}</p>
          </div>
          <div class="fw-bolder fs-4">
            <span class="me-3" v-if="controlPLC.battery < 10"><i class="fas fa-battery-empty"></i></span>
            <span class="me-3" v-else-if="controlPLC.battery < 25"><i class="fas fa-battery-quarter"></i></span>
            <span class="me-3" v-else-if="controlPLC.battery < 50"><i class="fas fa-battery-half"></i></span>
            <span class="me-3" v-else-if="controlPLC.battery < 75"><i class="fas fa-battery-three-quarters"></i></span>
            <span class="me-3" v-else><i class="fas fa-battery-full"></i></span>
            <span>{{ `${Math.floor(controlPLC.battery)} %` }}</span>
          </div>
        </div>
      </div>
        <ul class="nob-services">
          <div class="row">
            <div class="text-center">
              <p class="fw-bold">{{ $t('services.services') }}</p>
            </div>
            <div class="col-12" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('boot')">
                <span>{{ $t('rebootCard') }}</span>
              </li>
            </div>
            <div class="col-7" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('fpr-guardian')">
                <span>{{ $t('services.guardian') }}</span>
              </li>
            </div>
            <div class="col-5" v-if="this.authority">
              <li class="service text-center active" @click="this.serviceReboot('fpr-crm')">
                <span>{{ $t('services.crm') }}</span>
              </li>
            </div>
            <div class="col-12" v-if="services">
              <div class="row justify-content-center">
                <div class="col-6" v-for="(item, index) in services" :key="index">
                  <li class="service text-center" @click="this.serviceReboot(item.service)"
                    :class="{ active: item.counter >= 5 || item.name == 'DB' }">
                    <span>{{ item.name }}</span>
                  </li>
                </div>
              </div>
            </div>

            <div class="text-center">
              <hr />
              <p class="title mb-2 fw-bold">{{ $t('fastAccess') }}</p>
            </div>
            <div class="col-12 mt-2">
              <button type="button" class="btn btn-sm btn-outline-success w-100" @click="this.$router.go()">
                {{ $t('refreshPage') }}
              </button>
            </div>
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('automatic', `${$t('mode.descAutomatic')}`)">
                {{ $t('mode.automatic') }}
              </button>
            </div>
            <div class="col-6 mt-2">
              <button type="button" class="btn btn-sm btn-outline-warning w-100" :disabled="!this.dataFastAccess.reboot"
                :class="{ 'btn-outline-danger': !this.dataFastAccess.reboot }"
                @click="fastAccess('manual', `${$t('mode.descManual')}`)">
                {{ $t('mode.manual') }}
              </button>
            </div>
            <div class="offset-3 col-6 mt-2" v-if="controlPLC?.errorStatus">
              <button type="button" class="btn btn-sm btn-outline-success w-100"
                @click="fastAccess('errorReset', `${$t('errorReset')}`)">
                {{ $t('errorReset') }}
              </button>
            </div>
            <div class="col-12" v-if="controlPLC?.rosData">
              <div class="row">
                <div class="col-12 my-3">
                  <button type="button" class="btn btn-sm btn-outline-success w-100"
                    @click="goToTask('/go-charge')">
                    Şarja git
                  </button>
                </div>
                <div class="col-12 my-3">
                  <button type="button" class="btn btn-sm btn-outline-success w-100"
                    @click="goToTask('/go-tour')">
                    Tura çık
                  </button>
                </div>
                <div class="col-12 my-3">
                  <button type="button" class="btn btn-sm btn-warning w-100"
                    @click="goToTask('/stop')">
                    Durdur
                  </button>
                </div>
                <div class="col-12 my-1" v-for="(index, item) in this.config?.bilir?.location" :key="item">
                  <button type="button" class="btn btn-sm btn-outline-success w-100"
                    @click="goToTask(`/location?value=${index}`)">
                    {{ `${index} Konumdan devam et` }}
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3" v-else>
              <div v-for="n in $store.state.roboConfig.locationCount" :key="n" class="col-12 mt-1">
                <button type="button" class="btn btn-sm btn-outline-primary w-100" :disabled="!dataFastAccess.reboot"
                  :class="{ 'btn-outline-danger': !dataFastAccess.reboot }"
                  @click="fastAccess(`location${n}`, `${$t(`location`)} ${n}`)">
                  {{ `${$t(`location`)} ${n}` }}
                </button>
              </div>
            </div>


            <div class="col-12 mt-3">
              <div v-for="n in $store.state.roboConfig.locationCount" :key="n" class="col-12 mt-1">
                <button type="button" class="btn btn-sm btn-outline-primary w-100" :disabled="!dataFastAccess.reboot"
                  :class="{ 'btn-outline-danger': !dataFastAccess.reboot }"
                  @click="fastAccess(`location${n}`, `${$t(`location`)} ${n}`)">
                  {{ `${$t(`location`)} ${n}` }}
                </button>
              </div>
            </div>

            <div class="col-12">
              <div class="text-center mt-3">
                <p class="title mb-2 fw-bold">{{ $t('extraControl') }}</p>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-9">
                  <span>{{ $t('items.emergencyStop') }}</span>
                </div>
                <div class="col-3">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.emergencyStop }"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-9">
                  <span>{{ $t('items.limitSwitch') }}</span>
                </div>
                <div class="col-3">
                  <div class="status-manager">
                    <span class="status" :class="{ 'bg-success': this.controlPLC?.limitSwitch }"></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-if="controlPLC?.rosData">
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <span>{{ $t('items.spiral') }}</span>
                    </div>
                    <div class="col-3">
                      <div class="status-manager">
                        <span class="status" :class="{ 'bg-success': this.controlPLC?.helezon }"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <span>{{ $t('items.chargingContactor') }}</span>
                    </div>
                    <div class="col-3">
                      <div class="status-manager">
                        <span class="status" :class="{ 'bg-success': this.controlPLC?.contactor }"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <span>{{ $t('items.strobeLamb') }}</span>
                    </div>
                    <div class="col-3">
                      <div class="status-manager">
                        <span class="status" :class="{ 'bg-success': this.controlPLC?.blinker }"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <span>{{ $t('items.buzzer') }}</span>
                    </div>
                    <div class="col-3">
                      <div class="status-manager">
                        <span class="status" :class="{ 'bg-success': this.controlPLC?.buzzer }"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row">
                    <div class="col-9">
                      <span>{{ $t('items.fan') }}</span>
                    </div>
                    <div class="col-3">
                      <div class="status-manager">
                        <span class="status" :class="{ 'bg-success': this.controlPLC?.fan }"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 mt-2">
                  <button type="button" class="btn btn-sm btn-outline-success w-100" disabled>{{ `L: ${controlPLC?.motion?.leftEncoder}` }}</button>
                </div>
                <div class="col-6 mt-2">
                  <button type="button" class="btn btn-sm btn-outline-success w-100" disabled>{{ `R: ${controlPLC?.motion?.rightEncoder}` }}</button>
                </div>
              </div>
            </div>
            <div>
              <hr />
            </div>
          </div>
        </ul>
      </div>
    </div>
  </main>
  <footer>
    <div class="content">
      <p>{{ `© 2025` }}</p>
      <p class="fs-2">{{ $t(`fpr.errorDesc.${controlPLC?.errorCode}`) }}</p>
      <p>{{ `${this.machineCode} v${this.version}` }}</p>
    </div>
  </footer>
  <div class="specialLoginArea" v-if="!this.auth?.authority">
    <loginPage />
  </div>
</template>

<style>
.specialLoginArea {
  position: absolute;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

:root {
  --c-theme: #5396da;
}
</style>

<script>
import { mapMutations } from 'vuex'
import { AtomSpinner } from 'epic-spinners'
import loginPage from '@/login.vue'

export default {
  components: {
    AtomSpinner,
    loginPage,
  },
  data() {
    return {
      // true on localhost so local serve is not redirected to *.itechrobotics.com.tr after login
      devStatus: ['localhost', '127.0.0.1'].includes(window.location.hostname),
      machineCode: localStorage.machineCode || 'FPR',
      machineTypes: ['CFR', 'FPR', 'CPM', 'SPR'],
      version: '1.20.4_1',
      time: 0,
      breadcrumb: [this.$t('nav.home')],
      selected_machine: localStorage.selected_machine ? String(localStorage.selected_machine) : '',
      machineNetwork: false,
      externalToken: undefined,
      externalSelectedMachine: undefined,
      machineAddr: {
        'CFR': 'imom',
        'FPR': 'ibold',
        'SPR': 'ican',
        'CPM': 'colostrum'
      },
      currentMachine: undefined,
      config: undefined,
      spinners: true,
      dataFastAccess: {
        reboot: true,
        errorReset: true
      },
      navOptionsBarShow: false,
      externalFeedingStatus: true,
      systemDate: {
        autoSet: false,
        date: '0000-00-00',
        hour: '00:00:00'
      },
      changeDateStatus: false,
      intervals: []
    };
  },
  methods: {
    ...mapMutations(['collapse', 'fullScreen', 'navOptionsBar', 'logout']),
    dropdown(event) {
      event.target.parentElement.parentElement.classList.toggle('active')
      event.target.parentElement.parentElement.classList.toggle('open')
    },
    navOptionsBar0() {
      this.navOptionsBar()
      this.navOptionsBarShow = !this.navOptionsBarShow
    },
    trackInterval(id) {
      this.intervals.push(id)
      return id
    },
    async serviceReboot(service) {
      if (await this.$functions.alerts_check(this.$t('alerts.restartService'))) {
        this.$axios.post({ uri: '/serviceReboot', valueData: { value: service } })
      }
    },
    userSettings() {
      if (!this.navOptionsBarShow) this.navOptionsBar0()
    },
    async dateChange() {
      const datePayload = { ...this.systemDate }
      if (datePayload.autoSet) {
        const now = new Date()
        datePayload.date = now.toISOString().slice(0, 10)
        datePayload.hour = now.toTimeString().slice(0, 8)
      }
      if (!this.config || Array.isArray(this.config)) {
        this.$alertBox.warning(this.$t('op.missingData'))
        return
      }
      await this.$axios.post({
        port: 4000,
        uri: '/config',
        valueData: { ...this.config, systemDate: datePayload }
      })
    },
    async closePopup() {
      this.$router.replace({ query: null })
      this.pageNumber = 1
    },
    async change_lang(lang) {
      const next = lang || 'tr'
      localStorage.lang = next
      const locale = this.$i18n.locale
      if (locale && typeof locale === 'object' && 'value' in locale) locale.value = next
      else this.$i18n.locale = next
    },
    async checkByToken() {

      const val = Number(this.externalSelectedMachine);
      if (val && !isNaN(val)) {
        localStorage.selected_machine = this.externalSelectedMachine
        this.$router.push({ query: null })
      }

      if (this.externalToken?.length > 0) {
        localStorage.token = this.externalToken
        this.$router.push({ query: null })
      }

      if (localStorage.token && localStorage.token != undefined) {
        try {
          var req = await this.$axios.get({ orjUri: '/checkByToken' })
          if (req.newToken) {
            const response = req
            localStorage.token = response?.newToken
            this.$store.state.auth = {
              authority: true,
              role: response?.role,
              mail: response?.mail,
              time: response?.exp,
              authorization: response?.authority,
              tecnicalPersonal: req.authority?.machine?.read ? true : false,
              machines: response?.machines
            }
          } else this.logout()
        } catch (error) {
          if (error.response) this.$alertBox.warning(error.response.data)
          else console.error(error.message)
          this.logout()
          this.$router.go()
        }
      } else this.logout()
      this.spinners = false
      if (this.$route.query.token?.length > 0) this.$router.push({ query: {} })
    },
    async onMachineTypeChange() {
      localStorage.machineCode = this.machineCode
      const list = this.filteredMachines
      const current = list.find(x => x.machine_id == this.selected_machine)
      if (!current && list.length) {
        this.selected_machine = String(list[0].machine_id)
      }
    },
    isMachineOnline(machine) {
      if (!machine?.change_date) return false
      return Date.now() - new Date(machine.change_date).getTime() <= 15 * 60 * 1000
    },
    async exitAccount() {
      if (await this.$functions.alerts_check(this.$t('login.areYouSure_logout'))) {
        this.logout()
      }
    },
    async getMyMachines() {
      const machine_data = await this.$axios.get({ orjUri: '/machines/getMyMachine' })
      this.$store.state.machine_data = machine_data.data
        ?.filter((x) => x.remote_ip != null)
        .sort((a, b) => a.code?.split("-")[1] - b.code.split("-")[1]);

      this.selected_machine = localStorage.selected_machine

      let machineList = this.$store.state.machine_data
      let findMachine = machineList?.find(x => x.machine_id == this.selected_machine)
      const selectedType = findMachine?.code?.split('-')[0]
      if (selectedType && this.machineTypes.includes(selectedType)) {
        this.machineCode = selectedType
        localStorage.machineCode = selectedType
      }
      let subDomain = this.machineAddr[selectedType]

      if (window.location.host.split('.')[0] != subDomain && !this.devStatus) {
        localStorage.removeItem('selected_machine')
        this.selected_machine = localStorage.selected_machine
        this.baseControl(subDomain)
      }
      else if (!findMachine) localStorage.removeItem('selected_machine')
      if ((machineList?.length > 0 && !this.selected_machine)) {
        const defaultMachine = machineList.find(x => x.code.split('-')[0] == this.machineCode)
        const defaultId = defaultMachine ? String(defaultMachine.machine_id) : ''
        localStorage.selected_machine = defaultId
        this.selected_machine = defaultId
        this.$store.state.selected_machine = defaultId
      } else {
        this.selected_machine = this.normalizeMachineId(this.selected_machine)
        this.$store.state.selected_machine = this.selected_machine
      }

      var timeDiff = 0
      this.trackInterval(setInterval(() => {
        const systemDate = this.$store.state.systemDate
        if (!systemDate) {
          this.machineNetwork = false
          return
        }
        const parsed = new Date(systemDate)
        if (Number.isNaN(parsed.getTime())) {
          this.machineNetwork = false
          return
        }
        if (timeDiff == 0) timeDiff = new Date().getTime() - parsed.getTime()
        let realDiff = new Date() - parsed
        this.machineNetwork = timeDiff - realDiff < 5000
      }, 1000));

      await this.$socket.connect()
    },
    normalizeMachineId(id) {
      if (id == null || id === '') return ''
      return String(id)
    },
    async baseControl(subDomain) {
      if (!this.$store.state.auth.authority) return
      const machineId = this.selected_machine || localStorage.selected_machine
      const baseURL = `https://${subDomain || 'imom'}.itechrobotics.com.tr`
      // Always navigate to the product panel (CFR→imom, SPR→ican, …).
      // Local FPR stay-here is handled in the selected_machine watch, not here.
      window.location.href = `${baseURL}?externalToken=${localStorage.token}&externalSelectedMachine=${machineId}`
    },
    async fastAccess(type, desc) {

      if (await this.$functions.alerts_check(this.$t('alerts.n_areYouSure', { name: type }))) {
        if (type == "reboot") {
          this.dataFastAccess.reboot = false;
          this.$socketPLC?.emit("PLC", {
            process: "W",
            type: "M",
            addr: 43,
            value: 1,
            after: 0,
          });
          setTimeout(() => {
            this.dataFastAccess.reboot = true;
          }, 5000);
        }
        else if (type == "manual") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'D', addr: 514, value: 1 } })
        else if (type == "automatic") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'D', addr: 514, value: 0 } })
        else if (type == "errorReset") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'D', addr: 579, value: 1, after: 0 } })

        else if (type == "location1") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 30, value: 1, after: 0 }})
        else if (type == "location2") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 123, value: 1, after: 0 }})
        else if (type == "location3") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 122, value: 1, after: 0 }})
        else if (type == "location4") this.$axios.post({ port: 3020, uri: '/plc', valueData: { type: 'M', addr: 125, value: 1, after: 0 }})
        this.$alertBox.info(this.$t('op.success', { name: desc }))
      }
    },
    async goToTask(task) {
      if (await this.$functions.alerts_check(this.$t('alerts.areYouSure'))) {
          this.$axios.post({ port: 3070, uri: `${task}` })
      }
    }
  },
  async mounted() {

    this.selected_machine = localStorage.selected_machine

    const urlParams = new URLSearchParams(window.location.search);
    this.externalToken = urlParams.get('externalToken')
    this.externalSelectedMachine = urlParams.get('externalSelectedMachine')

    await this.checkByToken();
    await this.getMyMachines()
    if (window.innerWidth <= 960) {
      document.querySelector('body').classList.add('collapse')
    }

    if (this.selected_machine != null && this.selected_machine != undefined && this.authority) {
      const cfg = await this.$axios.get({ port: 4000, uri: '/config', silent: true })
      if (cfg && !Array.isArray(cfg)) this.config = cfg
      // Banner already shows awaitMachine — do not spam toasts every 5s
      const firstAlert = this.trackInterval(setInterval(async () => {
        const next = await this.$axios.get({ port: 4000, uri: '/config', silent: true })
        if (next && !Array.isArray(next)) this.config = next
        if (this.config?.producer) clearInterval(firstAlert)
      }, 5000))
    }
    if (this.authority) {
      this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc', silent: true })
      const errorCodeDescInterval = this.trackInterval(setInterval(async () => {
        if (this.$store.state.errorCodeDesc != undefined && !Array.isArray(this.$store.state.errorCodeDesc)) clearInterval(errorCodeDescInterval)
        else this.$store.state.errorCodeDesc = await this.$axios.get({ uri: '/systemlog/errordesc', silent: true })
      }, 5000))
    }

    const configInterval = this.trackInterval(setInterval(async () => {
      if (this.config && !Array.isArray(this.config)) {
        this.spinners = false
        this.$store.state.producer = this.config.producer
        this.$store.state.systems = this.config.systems
        this.$store.state.roboConfig.code = `${this.config?.type || 'XXX'}_${this.config?.sub_id?.toString().padStart(4, '0')}_${this.config?.city}`
        if (this.$store.state?.producer) document.documentElement.style.setProperty('--c-theme', this.$store.state.producer.color)
        this.$store.state.roboConfig.locationCount = Number(this.config?.sub_id?.toString()?.charAt(this.config?.sub_id?.toString().length - 1)) || 4
        clearInterval(configInterval)
      } else if (this.authority) {
        const next = await this.$axios.get({ port: 4000, uri: '/config', silent: true })
        if (next && !Array.isArray(next)) this.config = next
      }
    }, 1000))

    this.trackInterval(setInterval(
      () => {
        this.checkByToken()
      },
      3 * 60 * 1000
    ))
    this.trackInterval(setInterval(() => {
      this.time = this.$store.state.auth.time - Number((new Date().getTime() / 1000).toFixed())
    }, 1000))
  },
  beforeUnmount() {
    this.intervals.forEach(id => clearInterval(id))
    this.intervals = []
  },
  computed: {
    license() {
      return this.$store.state.roboConfig.license
    },
    stationMonitoring() {
      return this.$store.state.stationMonitoring
    },
    services() {
      return this.$store.state.services
    },
    stationCount() {
      return this.$store.state.roboConfig.stationCount
    },
    controlPLC() {
      return this.$store.state.controlPLC
    },
    auth() {
      return this.$store.state.auth
    },
    authority() {
      return this.$store.state.auth?.authority
    },
    producer() {
      return this.$store.state.producer
    },
    machine_data() {
      return this.$store.state.machine_data
    },
    filteredMachines() {
      const list = this.$store.state.machine_data || []
      return list
        .filter(x => String(x.code || '').split('-')[0] === this.machineCode)
        .map(x => ({ ...x, network: this.isMachineOnline(x) }))
    },
    authorization() {
      return this.$store.state.auth?.authorization || {}
    }
  },
  watch: {
    selected_machine(newVal, oldVal) {
      const id = this.normalizeMachineId(newVal)
      const prev = this.normalizeMachineId(oldVal)
      if (!id || id === prev) return
      if (!prev) return
      if (!this.$store.state.auth.authority) return

      const findMachine = this.$store.state.machine_data?.find(x => String(x.machine_id) === id)
      if (!findMachine) return

      const prefix = String(findMachine.code || '').split('-')[0]
      const subDomain = this.machineAddr[prefix]
      const hostSub = window.location.host.split('.')[0]
      const stayLocal = this.devStatus && prefix === this.machineCode

      if (hostSub === subDomain || stayLocal) {
        localStorage.selected_machine = id
        this.$router.go()
      } else if (subDomain) {
        localStorage.selected_machine = id
        this.baseControl(subDomain)
      }
    }
  }
}
</script>
